import { apiRequest } from '../../apiRequest';

export const deleteOrder = async (orderId) => {
    return apiRequest(`/admin/lead/leads/orders/${orderId}`, {
        method: 'DELETE',
        defaultErrorMessage: `Failed to delete order #${orderId}`,
    });
};
